// extracted by mini-css-extract-plugin
module.exports = {"widthSlider":"line-width-slider_widthSlider__jAmU8"};